import React, { useState, useEffect } from 'react';
import Apiconnect from "../services/Apiconnect.js";
import { Modal, Button, Spinner } from 'react-bootstrap';

const Editprofile = () => {
  // State for user data
  const [userData, setUserData] = useState({
    name: '',
    email: '',
    phone: ''
  });

  // State for form inputs
  const [formData, setFormData] = useState({
    fname: '',
    lname: '',
    phone: ''
  });

  // States for UI
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [message, setMessage] = useState({ text: '', type: '' });

  // Fetch user info on component mount
  useEffect(() => {
    fetchUserInfo();
  }, []);

  // Function to fetch user information
  const fetchUserInfo = async () => {
    setIsPageLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await Apiconnect.postData("auth/userinfo", token);
      console.log("User info response:", response.data);
      console.log(token);

      if (response.data && response.data.status === 1) {
        const user = response.data.user;
        setUserData(user);

        setFormData({
          fname: user.fname || '',
          lname: user.lname || '',
          phone: user.phone || ''
        });
      } else {
        setMessage({
          text: response.data?.message || 'Failed to load user data',
          type: 'danger'
        });
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      setMessage({
        text: 'An error occurred while loading user data',
        type: 'danger'
      });
    } finally {
      setIsPageLoading(false);
    }
  };

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // Handle profile update
  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage({ text: '', type: '' });

    try {
      const token = localStorage.getItem('token');
      const response = await Apiconnect.postData("auth/userupdate", formData, token);

      if (response.data && response.data.status === 1) {
        setMessage({
          text: 'Profile updated successfully!',
          type: 'success'
        });
        setShowModal(false);
        // Fetch updated user info
        fetchUserInfo();
      } else {
        setMessage({
          text: response.data?.message || 'Failed to update profile',
          type: 'danger'
        });
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      setMessage({
        text: 'An error occurred while updating profile',
        type: 'danger'
      });
    } finally {
      setIsLoading(false);
    }
  };



  // Modal handlers
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  return (
    <div className="container-fluid">
      <div className="row mt-4 mb-5">
        <div className="col-md-8 mx-auto">
          {/* Alert message */}
          {message.text && (
            <div className={`alert alert-${message.type} alert-dismissible fade show`} role="alert">
              {message.text}
              <button type="button" className="btn-close" onClick={() => setMessage({ text: '', type: '' })}></button>
            </div>
          )}

          <div className="card shadow">
            <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
              <h4 className="mb-0">User Profile</h4>
              <button
                className="btn btn-light"
                onClick={handleOpenModal}
                disabled={isPageLoading}
              >
                Edit Profile
              </button>
            </div>

            <div className="card-body">
              {isPageLoading ? (
                <div className="text-center py-4">
                  <Spinner animation="border" role="status" variant="primary">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                  <p className="mt-2">Loading profile information...</p>
                </div>
              ) : (
                <div className="row">
                  <div className="col-md-4 mb-4 mb-md-0">
                    <div className="text-center">
                      <div className="position-relative mx-auto" style={{ width: '150px', height: '150px' }}>
                        <img
                          src="https://img.freepik.com/free-vector/follow-me-social-business-theme-design_24877-52234.jpg?t=st=1744020490~exp=1744024090~hmac=40596a3b23db6b6e5b69234af0502223ec35c8755dfffd245299a36bccbf1a8b&w=826"
                          alt="Profile"
                          className="rounded-circle img-thumbnail"
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-8">
                    <div className="table-responsive">
                      <table className="table table-borderless">
                        <tbody>
                          <tr>
                            <th style={{ width: '30%' }}>Full Name:</th>
                            <td>{`${userData.fname || ''} ${userData.lname || ''}`.trim() || 'Not provided'}</td>
                          </tr>

                          <tr>
                            <th>Email:</th>
                            <td>{userData.email || 'Not provided'}</td>
                          </tr>
                          <tr>
                            <th>Phone Number:</th>
                            <td>{userData.phone || 'Not provided'}</td>
                          </tr>
                          <tr>
                            <th>User Type:</th>
                            <td>{userData.user_typ || 'Not specified'}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Edit Profile Modal */}
      <Modal show={showModal} onHide={handleCloseModal} centered backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Edit Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleUpdateProfile}>
            <div className="form-group mb-3">
              <label className="form-label">First Name</label>
              <input
                type="text"
                className="form-control"
                name="fname"
                value={formData.fname}
                onChange={handleInputChange}
                placeholder="Enter your first name"
                required
              />
            </div>

            <div className="form-group mb-3">
              <label className="form-label">Last Name</label>
              <input
                type="text"
                className="form-control"
                name="lname"
                value={formData.lname}
                onChange={handleInputChange}
                placeholder="Enter your last name"
              />
            </div>

            <div className="form-group mb-3">
              <label className="form-label">Phone Number</label>
              <input
                type="text"
                className="form-control"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="Enter your phone number"
              />
            </div>

            <div className="d-flex justify-content-end gap-2 mt-4">
              <Button variant="secondary" onClick={handleCloseModal} disabled={isLoading}>
                Cancel
              </Button>
              <Button
                type="submit"
                variant="primary"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    <span className="ms-2">Saving...</span>
                  </>
                ) : (
                  'Save Changes'
                )}
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Editprofile;